import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import ArrowDropUp from '@material-ui/icons/ArrowDropUp';
import ArrowForward from '@material-ui/icons/ArrowForward';
import ArrowRight from '@material-ui/icons/ArrowRight';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import CheckIcon from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import Close from '@material-ui/icons/Close';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Code from '@material-ui/icons/Code';
import Delete from '@material-ui/icons/Delete';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import ErrorIcon from '@material-ui/icons/Error';
import FormatBold from '@material-ui/icons/FormatBold';
import FormatItalic from '@material-ui/icons/FormatItalic';
import FormatListBulleted from '@material-ui/icons/FormatListBulleted';
import FormatListNumbered from '@material-ui/icons/FormatListNumbered';
import FormatShapesIcon from '@material-ui/icons/FormatShapes';
import FormatUnderlined from '@material-ui/icons/FormatUnderlined';
import ForumOutlinedIcon from '@material-ui/icons/ForumOutlined';
import Fullscreen from '@material-ui/icons/Fullscreen';
import FullscreenExit from '@material-ui/icons/FullscreenExit';
import Image from '@material-ui/icons/Image';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import Link from '@material-ui/icons/Link';
import ModeCommentIcon from '@material-ui/icons/ModeComment';
import MusicNoteIcon from '@material-ui/icons/MusicNote';
import Email from '@material-ui/icons/EmailOutlined';
import CheckCircle from '@material-ui/icons/CheckCircle';
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';

import OpenInNew from '@material-ui/icons/OpenInNew';
import PanTool from '@material-ui/icons/PanTool';
import PeopleIcon from '@material-ui/icons/People';
import PictureAsPdf from '@material-ui/icons/PictureAsPdf';
import SlideshowIcon from '@material-ui/icons/Slideshow';
import TitleIcon from '@material-ui/icons/Title';
import VideocamIcon from '@material-ui/icons/Videocam';
import WarningIcon from '@material-ui/icons/Warning';
import ExtensionIcon from '@material-ui/icons/Extension';
import AssignmentIcon from '@material-ui/icons/Assignment';
import Functions from '@material-ui/icons/Functions';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Group from '@material-ui/icons/Group';
import Help from '@material-ui/icons/Help';
import Stop from '@material-ui/icons/Stop';
import Mic from '@material-ui/icons/Mic';
import SettingsIcon from '@material-ui/icons/Settings';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';

import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import AddIcon from '@material-ui/icons/Add';
import ScheduleIcon from '@material-ui/icons/Schedule';
import SchoolIcon from '@material-ui/icons/School';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import RemoveIcon from '@material-ui/icons/RemoveCircle';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

import AltText from './AltText.svg';
import FormatStrikethrough from './FormatStrikethrough.svg';
import CopyLink from './CopyLink.svg';
import Copy from './Copy.svg';
import Excel from './Excel.svg';
import FontColor from './FontColor.svg';
import Play from './Play.svg';
import Pause from './Pause.svg';
import Ppt from './Ppt.svg';
import Word from './Word.svg';
import H1 from './H1.svg';
import H2 from './H2.svg';
import H3 from './H3.svg';
import Panopto from './Panopto.svg';
import Anonymous from './Anonymous.svg';
import PlanetEStream from './PlanetEStream.svg';
import SortDescending from './SortDescending.svg';
import SortAscending from './SortAscending.svg';
import QuestionMark from './QuestionMark.svg';
import Talis from './Talis.svg';
import BlockQuote from './BlockQuote.svg';
import OneDrive from './OneDrive.svg';
import GoogleDrive from './GoogleDrive.svg';
import Computer from './Computer.svg';
import Echo360 from './Echo360.svg';
import BigBlueButton from './BigBlueButton.svg';
import H5p from './H5p.svg';
import BibliU from './BibliU.svg';
import Handin from './Handin.svg';
import TurnitIn from './TurnitIn.svg';
import Quiz from './Quiz.svg';
import InlineQuiz from './InlineQuiz.svg';
import Templates from './Templates.svg';
import SSA from './SSA.svg';
import AppStoreLogo from './AppStoreLogo.svg';
import PlayStoreLogo from './PlayStoreLogo.svg';
import AulaLogo from './AulaLogo.svg';
import Announcement from './Announcement.svg';

export default {
  Announcement,
  AulaLogo,
  ArrowBack,
  ArrowDropDown,
  ArrowDropUp,
  ArrowForward,
  ArrowRight,
  AttachFileIcon,
  AltText,
  CheckIcon,
  ChevronLeft,
  Close,
  CloudDownloadIcon,
  CloudUploadIcon,
  Code,
  Copy,
  CopyLink,
  Delete,
  DragIndicatorIcon,
  ErrorIcon,
  Excel,
  FontColor,
  FormatBold,
  FormatItalic,
  FormatListBulleted,
  FormatListNumbered,
  FormatShapesIcon,
  FormatStrikethrough,
  FormatUnderlined,
  ForumOutlinedIcon,
  Fullscreen,
  FullscreenExit,
  Image,
  InsertDriveFileIcon,
  Link,
  ModeCommentIcon,
  MusicNoteIcon,
  OpenInNew,
  PanTool,
  PeopleIcon,
  PictureAsPdf,
  Ppt,
  SlideshowIcon,
  TitleIcon,
  VideocamIcon,
  Warning: WarningIcon,
  WarningIcon,
  Word,
  H1,
  H2,
  H3,
  ExtensionIcon,
  AssignmentIcon,
  Panopto,
  Pause,
  Play,
  Anonymous,
  VisibilityOff,
  Group,
  PlanetEStream,
  Talis,
  BlockQuote,
  OneDrive,
  GoogleDrive,
  Computer,
  Functions,
  Help,
  SettingsIcon,
  ArrowBackIosIcon,
  EditIcon,
  SaveIcon,
  AddIcon,
  ScheduleIcon,
  SchoolIcon,
  AddCircleOutlineIcon,
  RemoveIcon,
  HighlightOffIcon,
  Echo360,
  BigBlueButton,
  BibliU,
  Handin,
  H5p,
  TurnitIn,
  SSA,
  Quiz,
  Templates,
  Stop,
  Mic,
  Email,
  CheckCircle,
  CheckCircleOutlinedIcon,
  AppStoreLogo,
  PlayStoreLogo,
  SortDescending,
  SortAscending,
  SettingsOutlinedIcon,
  QuestionMark,
  InlineQuiz,
  MoreVertIcon,
  MoreHorizIcon,
};
